import { render, staticRenderFns } from "./ListSerial.vue?vue&type=template&id=0c7091c4"
import script from "./ListSerial.vue?vue&type=script&lang=js"
export * from "./ListSerial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports